{
  "banner": {
    "title": "Cookie Consent",
    "description": "We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking \"Accept All\", you consent to our use of cookies.",
    "learnMore": "Learn more",
    "learnMoreAria": "Learn more about our cookie and privacy policy"
  },
  "actions": {
    "customize": "Customize",
    "necessaryOnly": "Necessary Only",
    "acceptAll": "Accept All",
    "back": "Back",
    "save": "Save Preferences"
  },
  "preferences": {
    "title": "Cookie Preferences",
    "description": "Manage your cookie preferences. Some cookies are necessary for the site to function and cannot be disabled.",
    "necessary": {
      "title": "Necessary Cookies",
      "description": "Essential for the website to function properly. These cannot be disabled.",
      "alwaysOn": "Always on"
    },
    "analytics": {
      "title": "Analytics Cookies",
      "description": "Help us understand how visitors interact with our website by collecting anonymous information."
    },
    "marketing": {
      "title": "Marketing Cookies",
      "description": "Used to track visitors across websites to display relevant advertisements."
    }
  }
}
